import React from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CSSProvider } from "@perfectserve/css-styles-react";

interface ComingSoonProps {
  title?: string;
  description?: string;
  icon?: IconDefinition;
}

const ComingSoon = ({
  title = "Coming Soon",
  description = "This feature is currently in development.",
  icon,
}: ComingSoonProps) => {
  return (
    <CSSProvider>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-40 coming-soon-container">
        <div>
          {icon && (
            <div className="mb-15">
              <FontAwesomeIcon icon={icon} className="coming-soon-icon" />
            </div>
          )}
          <h1>{title}</h1>
          <div>{description}</div>
        </div>
      </div>
    </CSSProvider>
  );
};

export default ComingSoon;
